/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardMedia,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import FilterCenterFocusSharpIcon from '@material-ui/icons/FilterCenterFocusSharp';
import SaveIcon from '@material-ui/icons/Save';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/lib/ReactCrop.scss';
import PredictionDetails from './PredictionDetails';

const useStyles = makeStyles({
  card: { minHeight: (props) => `${props.height}vw` },
  media: {
    height: (props) => `${0.87 * props.height}vw`,
    margin: 'auto',
    objectFit: 'contain',
    width: '100%',
    position: 'relative',
  },
  container: {
    position: 'relative',
  },
  crosshair: {
    position: 'absolute',
    width: '100%',
    color: 'white',
    opacity: '0.3',
    transform: 'scale(0.7)',
    zIndex: 1,
  },
  button: {
    backgroundColor: '#2ca0f7',
    color: 'white',
    textTransform: 'none',
    fontFamily: 'Exo 2',
  },
  text: {
    color: 'white',
    fontSize: '1.5em',
    position: 'absolute',
    top: '75%',
    left: '39%',
  },
});

const Camera = ({
  componentImg = null,
  image,
  port,
  host,
  predictionDetails,
  predictionsList,
  onCapture,
  onSave,
  height = 25,
  xs = 5,
  crop,
  disabled = false,
  onCropChange,
  showCrosshair,
  setShowCrosshair,

  runPrediction,
  setRunPrediction,
}) => {
  const classes = useStyles({ height });
  return (
    <Grid item xs={xs} border={1}>
      <Card className={classes.card}>
        {crop ? (
          <ReactCrop
            src={`data:image/jpeg;base64,${image}`}
            crop={crop}
            className={classes.media}
            onChange={onCropChange}
            imageStyle={{ width: '100%', height: `${0.87 * height}vw` }}
          />
        ) : (
          <div className={`${classes.media} ${classes.container}`}>
            {showCrosshair && (
              <FilterCenterFocusSharpIcon
                id="calibration-overlay"
                className={`${classes.media} ${classes.crosshair}`}
              />
            )}
            <CardMedia
              className={classes.media}
              component="img"
              src={componentImg || `data:image/jpeg;base64,${image}`}
            />
            {componentImg && <p className={classes.text}>Prediction Failed</p>}
          </div>
        )}
        <CardActions>
          <Grid container justifyContent="space-around" alignItems="center">
            <Grid>
              <Grid>{host}</Grid>
              <Grid container justifyContent="center">
                {port}
              </Grid>
            </Grid>
            <Button
              size={height > 400 ? 'large' : 'medium'}
              disabled={disabled}
              className={classes.button}
              variant="contained"
              endIcon={<PhotoCamera />}
              disableElevation
              onClick={onCapture}
            >
              Capture
            </Button>
            {onSave && (
              <Button
                size={height > 400 ? 'large' : 'medium'}
                disabled={disabled}
                className={classes.button}
                variant="contained"
                endIcon={<SaveIcon />}
                disableElevation
                onClick={onSave}
              >
                Save
              </Button>
            )}
            {!crop && (
              <FormControlLabel
                label="Calibration overlay"
                control={
                  <Checkbox
                    checked={showCrosshair}
                    onChange={setShowCrosshair}
                  />
                }
              />
            )}
            {!crop && (
              <FormControlLabel
                label="Run prediction"
                control={
                  <Checkbox
                    checked={runPrediction}
                    onChange={setRunPrediction}
                  />
                }
              />
            )}
          </Grid>
        </CardActions>
      </Card>
      <PredictionDetails
        predictionDetails={predictionDetails}
        predictionsList={predictionsList}
      />
    </Grid>
  );
};

export default React.memo(Camera);
